import React, { useState } from "react";

function Search() {
  const [selectedTags, setSelectedTags] = useState([]);
  const [registered, setRegistered] = useState(null);

  const tags = [
    "Edu Tech",
    "Fin Tech",
    "SaaS",
    "Biotechnology",
    "eCommerce",
    "Healthtech",
    "Education",
  ];

  const toggleTagSelection = (tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  };

  const handleRegisterSelection = (status) => {
    setRegistered(status);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4 sm:py-8">
      {/* Search Bar */}
      <div className="w-full sm:max-w-sm md:max-w-md lg:max-w-lg mb-6">
        <div className="flex items-center bg-white rounded-lg shadow-md p-3">
         
          <input
            type="text"
            placeholder="Search"
            className="w-full ml-2 p-2 text-sm sm:text-base border-none focus:ring-0 focus:outline-none"
          />
        </div>
      </div>

      {/* Tag Selection */}
      <div className="bg-white p-4 sm:p-6 rounded-lg shadow-md w-full sm:max-w-sm md:max-w-md lg:max-w-lg mb-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {tags.map((tag, index) => (
            <button
              key={index}
              onClick={() => toggleTagSelection(tag)}
              className={`text-sm sm:text-base px-4 py-2 rounded-lg ${
                selectedTags.includes(tag)
                  ? "bg-green-200 text-green-700"
                  : "bg-gray-200 text-gray-700"
              } hover:bg-green-300 hover:text-green-800 transition`}
            >
              {tag}
            </button>
          ))}
        </div>
      </div>

      {/* Registered Section */}
      <div className="bg-white p-4 sm:p-6 rounded-lg shadow-md w-full sm:max-w-sm md:max-w-md lg:max-w-lg">
        <h2 className="text-sm sm:text-base md:text-lg font-medium text-gray-800 mb-4">
          Registered?
        </h2>
        <div className="flex justify-around">
          <button
            onClick={() => handleRegisterSelection("Yes")}
            className={`text-sm sm:text-base px-6 py-2 rounded-lg ${
              registered === "Yes"
                ? "bg-green-200 text-green-700"
                : "bg-gray-200 text-gray-700"
            } hover:bg-green-300 hover:text-green-800 transition`}
          >
            Yes
          </button>
          <button
            onClick={() => handleRegisterSelection("No")}
            className={`text-sm sm:text-base px-6 py-2 rounded-lg ${
              registered === "No"
                ? "bg-green-200 text-green-700"
                : "bg-gray-200 text-gray-700"
            } hover:bg-green-300 hover:text-green-800 transition`}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
}

export default Search;
